import { render, staticRenderFns } from "./viewAPI2.vue?vue&type=template&id=f9cb2e9a&scoped=true&"
import script from "./viewAPI2.vue?vue&type=script&lang=js&"
export * from "./viewAPI2.vue?vue&type=script&lang=js&"
import style0 from "./viewAPI2.vue?vue&type=style&index=0&id=f9cb2e9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cb2e9a",
  null
  
)

export default component.exports